import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["button", "selectedElement", "option", "selectedOption"]
  }

  static get values() {
    return { name: String, selected: { type: Array, default: [] } }
  }

  connect() {
    this.render()
  }

  apply() {
    let values = []

    this.optionTargets.forEach(option => {
      if (option.checked) {
        values.push(option.value)
      }
    })

    this.selectedValue = values
    this.render()
    this.dispatchFilterEvent()
  }

  remove(event) {
    this.selectedValue = this.selectedValue.filter(value => value !== event.params.option)
    this.render()
    this.dispatchFilterEvent()
  }

  clear() {
    this.selectedValue = []
    this.render()
  }

  render() {
    this.optionTargets.forEach(option => {
      if (!this.hasSelectedValue) {
        option.checked = false
        return
      }

      option.checked = this.selectedValue.includes(option.value)
    })

    if (this.hasButtonTarget) {
      this.buttonTarget.dataset.selectedFilters = this.selectedValue.length
    }

    this.showSelectedFilters()
  }

  showSelectedFilters() {
    this.selectedOptionTargets.forEach(selectedOption => {
      if (this.selectedValue.includes(selectedOption.dataset.value)) {
        selectedOption.classList.remove("d-none")
      } else {
        selectedOption.classList.add("d-none")
      }
    })
  }

  dispatchFilterEvent() {
    this.dispatch("filter", { detail: { name: this.nameValue, values: this.selectedValue } })
  }
}
